

export const getCampaignLiveStatus = {
    GET_CAMPAIGN_LIVE_STATUS_REQUEST: "GET_CAMPAIGN_LIVE_STATUS_V2_REQUEST",
    GET_CAMPAIGN_LIVE_STATUS_SUCCESS: "GET_CAMPAIGN_LIVE_STATUS_V2_SUCCESS",
    GET_CAMPAIGN_LIVE_STATUS_ERROR: "GET_CAMPAIGN_LIVE_STATUS_V2_ERROR"
}